import { Component } from 'js-component-framework';

/**
 * Component for instantiating World Population Counter.
 */
export default class WorldPopCounter extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    this.startingPop = parseInt('7255316400', 10);
    this.startingDate = new Date('09/11/2017');
    this.ratePerSecond = parseFloat('2.745');
    this.refreshRate = parseInt('2', 10);
    this.resultPop = '';
    this.finalPop = '';

    // Init
    window.onload = () => {
      setInterval(
        this.showPopulation.bind(this),
        this.refreshRate * 1000
      );
    };
  }

  /**
   * Get Population
   * @return {String} calculated world population
   */
  getPopulation() {
    const currDate = new Date();
    const dbd =
      Math.round((currDate.valueOf() - this.startingDate.valueOf()) / 1000) + 1;
    const currentPop = this.startingPop + (this.ratePerSecond * dbd);
    return Math.round(currentPop)
      .toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Show Population
   */
  showPopulation() {
    this.children.counter.innerHTML = this.getPopulation();
  }
}



// WEBPACK FOOTER //
// ./client/js/components/WorldPopCounter/WorldPopCounter.js